$(function () {
  function restructureDescriptionHTML() {
    //Grab additional details list items to append to variants
    var additionalDetails = $("#additionalDetails").remove();
    // console.log("additionalDetails", additionalDetails);

    //Grab description/details
    //https://regex101.com/r/digh2j/2
    var productDescriptionInfo = $(".ProductMeta__Description .Rte")
      .html()
      .split(/<.+?#([\w–\-"]+)#.+>/g);
    // console.log("productDescriptionInfo", { productDescriptionInfo });

    //If only one size found append to custom details and return
    if (productDescriptionInfo.length === 1) {
      $(".Rte").css("display", "block");
      $("p:contains('Details')").remove();
      let productDetails = $(".ProductMeta__Description .Rte li").remove();
      // console.log("productDetails", { productDetails });

      let detailsHtml = "";
      productDetails.each(function (index) {
        detailsHtml += "<li>" + $(productDetails[index]).html() + "</li>";
      });
      $("#customDetails").append(
        $("<p/>", {
          html: buildDetailsHtml(detailsHtml, additionalDetails),
        })
      );
      return;
    }

    //Else append description which is first element
    var descriptionForAllVariants = productDescriptionInfo[0];
    // console.log("descriptionForAllVariants", { descriptionForAllVariants });
    $("#customDescription").append("<p>" + descriptionForAllVariants + "</p>");

    //Loop through variants and build custom details
    var i = 1;
    while (i <= productDescriptionInfo.length - 1) {
      let variantDetails = productDescriptionInfo[i + 1].split("+");
      let variantName = productDescriptionInfo[i].replace(/[. "]/g, "");
      // console.log("variantDetails, variantName", { variantDetails }, { variantName });

      //for (var j = 0; j < variantDetails.length - 1; j++) {
      $("#customDetails").append(
        $("<p/>", {
          class: "variant-description" + variantName,
          html: buildDetailsHtml(variantDetails.join(""), additionalDetails),
        })
      );
      //}
      i = i + 2;
    }
  }

  function showActiveVariantCopy() {
    var variantSelectButtons = document.getElementsByClassName("SizeSwatch__Radio");
    for (var i = 0; i < variantSelectButtons.length; i++) {
      if (variantSelectButtons[i].checked) {
        var variantName = variantSelectButtons[i].value.replace(/[. "]/g, "");
        changeActiveElements(variantName);
      }
    }
  }

  function changeActiveElements(selectedVariantTitle) {
    var variantDescriptions = document.getElementsByClassName(
      "variant-description" + selectedVariantTitle
    );
    var allVariantDescriptions = document.querySelectorAll(
      "[class^='variant-description']"
    );
    
    // Hide all variant descriptions
    for (var i = 0; i < allVariantDescriptions.length; i++) {
      allVariantDescriptions[i].style.display = "none";
    }
    
    // Only show the first matching variant description
    if (variantDescriptions.length > 0) {
      variantDescriptions[0].style.display = "block";
      
      // Hide any duplicate elements with the same class
      for (var i = 1; i < variantDescriptions.length; i++) {
        variantDescriptions[i].style.display = "none";
      }
    }
  }

  function buildDetailsHtml(details, additionalDetails) {
    var detailsHtml = "";
    if (details) {
      detailsHtml += "<ul>" + details + "</ul>";
    }
    if (additionalDetails && additionalDetails.length > 0) {
      detailsHtml += "<ul>";
      additionalDetails.find("li").each(function (index) {
        detailsHtml += "<li>" + $(this).html() + "</li>";
      });
      detailsHtml += "</ul>";
    }
    return detailsHtml;
  }

  document.addEventListener("variant:changed", function (e) {
    var variant = e.detail.variant;
    var variantName = variant.title.replace(/[. "]/g, "");
    changeActiveElements(variantName);
  });

  restructureDescriptionHTML();
  showActiveVariantCopy();

  /**
   * Filter product images by SKU for multiple variant products
   * This only applies to products with multiple variants - single variant products show all images
   */
  function setupProductImageFiltering() {
    // Check if we're on a product page
    const productContainer = document.querySelector('.Product');
    if (!productContainer) return;

    // Get product data - try different possible IDs for the product JSON
    let productData = {};
    const possibleJsonElements = [
      'ProductJson-product-template',
      'ProductJson-template',
      'ProductJson'
    ];
    
    for (const elementId of possibleJsonElements) {
      const jsonElement = document.getElementById(elementId);
      if (jsonElement) {
        try {
          productData = JSON.parse(jsonElement.textContent);
          break;
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    }
    
    // If we couldn't find product data, try to get it from the global window object
    if (!productData.id && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      productData = window.ShopifyAnalytics.meta.product;
    }
    
    // Still no product data, exit
    if (!productData.id) {
      console.warn('Could not find product data, exiting image filtering setup');
      return;
    }
    
    // Only apply filtering for multiple variant products
    if (!productData.variants || productData.variants.length <= 1) {
      console.log('Single variant product, not applying image filtering');
      return;
    }
    
    console.log('Multiple variant product detected, setting up image filtering');
    
    // Store original slide elements for restoration if needed
    const originalSlides = Array.from(document.querySelectorAll('.Product__Slideshow .Carousel__Cell'));
    if (originalSlides.length === 0) {
      console.warn('No slides found, exiting image filtering setup');
      return;
    }
    
    // Function to filter slides by variant SKU
    function filterSlidesByVariantSKU(variantSKU) {
      if (!variantSKU) {
        console.warn('No SKU provided, not filtering images');
        return;
      }
      
      // Helper function to escape special regex characters
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
      }
      
      console.log(`Filtering slides for variant SKU: ${variantSKU} (using exact matching)`);
      
      try {
        // Get all slides
        const slideshow = document.querySelector('.Product__Slideshow');
        const flickityInstance = Flickity.data(slideshow);
        if (!flickityInstance) {
          console.warn('No Flickity instance found, exiting image filtering');
          return;
        }
        
        // Store the current variant selection state
        const currentVariantId = document.querySelector('[name="id"]')?.value;
        
        // Get current index to try to maintain position
        const currentIndex = flickityInstance.selectedIndex;
        
        // Create a new array to hold the slides we want to keep
        const slidesToKeep = [];
        
        // Find slides that match the SKU
        originalSlides.forEach((slide) => {
          const slideClone = slide.cloneNode(true);
          const altText = slideClone.querySelector('img')?.alt || '';
          
          // Check if alt text contains the exact SKU (not just as a substring)
          // Using regex to match the exact SKU with word boundaries
          const escapedSKU = escapeRegExp(variantSKU);
          const skuRegex = new RegExp(`\\b${escapedSKU}\\b`);
          if (skuRegex.test(altText) || altText === variantSKU) {
            slidesToKeep.push(slideClone);
          }
        });
        
        // If no slides match the SKU, show all slides
        if (slidesToKeep.length === 0) {
          console.log(`No slides exactly match the SKU "${variantSKU}", showing all slides as fallback`);
          originalSlides.forEach(slide => {
            slidesToKeep.push(slide.cloneNode(true));
          });
        } else {
          console.log(`Found ${slidesToKeep.length} slides that exactly match SKU "${variantSKU}"`);
        }
        
        // Destroy and recreate Flickity to avoid DOM manipulation errors
        flickityInstance.destroy();
        
        // Clear the slideshow
        while (slideshow.firstChild) {
          slideshow.removeChild(slideshow.firstChild);
        }
        
        // Add the slides we want to keep
        slidesToKeep.forEach(slide => {
          slideshow.appendChild(slide);
        });
        
        // Make sure images are loaded before initializing Flickity
        const images = slideshow.querySelectorAll('img');
        let loadedImages = 0;
        
        // Function to initialize Flickity once images are loaded
        const initFlickity = () => {
          // Configure options based on number of slides
          const options = {
            prevNextButtons: true,
            pageDots: true,
            wrapAround: true,
            cellAlign: 'left',
            contain: true,
            draggable: true,
            // Ensure events are properly bound
            watchCSS: false,
            resize: true,
            // Make sure Flickity rebinds all event handlers
            initialIndex: 0
          };
          
          // Special handling for single image
          if (slidesToKeep.length === 1) {
            console.log('Only one image for this variant, disabling carousel features');
            
            // For a single image, disable unnecessary carousel features
            options.prevNextButtons = false;
            options.pageDots = false;
            options.wrapAround = false;
            options.draggable = false;
            
            // Add a class to the slideshow to allow for custom styling
            slideshow.classList.add('single-image-slideshow');
          } else {
            // Remove the single image class if it exists
            slideshow.classList.remove('single-image-slideshow');
          }
          
          // Completely remove any existing Flickity instance and data
          if (typeof Flickity.data(slideshow) !== 'undefined') {
            Flickity.data(slideshow).destroy();
          }
          
          // Remove any existing Flickity-related classes and elements
          slideshow.classList.remove('flickity-enabled');
          const existingDots = slideshow.parentNode.querySelector('.flickity-page-dots');
          if (existingDots) {
            existingDots.parentNode.removeChild(existingDots);
          }
          
          // Remove any existing button container
          const existingButtons = slideshow.parentNode.querySelector('.flickity-prev-next-button');
          if (existingButtons) {
            existingButtons.parentNode.removeChild(existingButtons);
          }
          
          // Reinitialize Flickity with the adjusted options
          const newFlickity = new Flickity(slideshow, options);
          
          // Force Flickity to update its UI elements
          setTimeout(() => {
            newFlickity.resize();
            
            // Manually rebind click events for dots if needed
            const dots = slideshow.parentNode.querySelectorAll('.flickity-page-dots .dot');
            dots.forEach((dot, index) => {
              dot.addEventListener('click', function() {
                newFlickity.select(index);
              });
            });
            
            // Try to restore position (only relevant for multiple images)
            if (slidesToKeep.length > 1) {
              const targetIndex = Math.min(currentIndex, slidesToKeep.length - 1);
              if (targetIndex > 0) {
                newFlickity.select(targetIndex, false, true);
              }
            }
            
            // Ensure variant selectors (gold color options) work properly
            // This is needed because we've modified the DOM which might affect event handlers
            const variantSelectors = document.querySelectorAll('.ProductForm__Option .SizeSwatch');
            if (variantSelectors.length > 0) {
              console.log('Ensuring variant selectors work properly');
              
              // Restore the current variant selection if it exists
              if (currentVariantId) {
                const currentInput = document.querySelector(`input[name="id"][value="${currentVariantId}"]`);
                if (currentInput) {
                  currentInput.checked = true;
                }
              }
              
              // Trigger a change event on the product form to reinitialize variant selectors
              const productForm = document.querySelector('.ProductForm');
              if (productForm) {
                const event = new CustomEvent('product:updated', { bubbles: true });
                productForm.dispatchEvent(event);
              }
            }
          }, 100);
        };
        
        // Check if all images are loaded
        if (images.length === 0) {
          // No images, initialize immediately
          initFlickity();
        } else {
          // Wait for images to load or timeout after 2 seconds
          const timeout = setTimeout(() => {
            console.log('Image loading timed out, initializing Flickity anyway');
            initFlickity();
          }, 2000);
          
          images.forEach(img => {
            if (img.complete) {
              loadedImages++;
              if (loadedImages === images.length) {
                clearTimeout(timeout);
                initFlickity();
              }
            } else {
              img.onload = () => {
                loadedImages++;
                if (loadedImages === images.length) {
                  clearTimeout(timeout);
                  initFlickity();
                }
              };
              img.onerror = () => {
                loadedImages++;
                if (loadedImages === images.length) {
                  clearTimeout(timeout);
                  initFlickity();
                }
              };
            }
          });
        }
      } catch (error) {
        console.error('Error filtering slides:', error);
        // Try to recover by showing all slides
        try {
          const slideshow = document.querySelector('.Product__Slideshow');
          const flickityInstance = Flickity.data(slideshow);
          
          if (flickityInstance) {
            flickityInstance.destroy();
            
            // Clear the slideshow
            while (slideshow.firstChild) {
              slideshow.removeChild(slideshow.firstChild);
            }
            
            // Add all original slides
            originalSlides.forEach(slide => {
              slideshow.appendChild(slide.cloneNode(true));
            });
            
            // Configure options based on number of slides
            const options = {
              prevNextButtons: true,
              pageDots: true,
              wrapAround: true,
              cellAlign: 'left',
              contain: true,
              draggable: true,
              // Ensure events are properly bound
              watchCSS: false,
              resize: true,
              // Make sure Flickity rebinds all event handlers
              initialIndex: 0
            };
            
            // Special handling for single image
            if (originalSlides.length === 1) {
              console.log('Only one image available, disabling carousel features');
              options.prevNextButtons = false;
              options.pageDots = false;
              options.wrapAround = false;
              options.draggable = false;
              slideshow.classList.add('single-image-slideshow');
            } else {
              slideshow.classList.remove('single-image-slideshow');
            }
            
            // Completely remove any existing Flickity instance and data
            if (typeof Flickity.data(slideshow) !== 'undefined') {
              Flickity.data(slideshow).destroy();
            }
            
            // Remove any existing Flickity-related classes and elements
            slideshow.classList.remove('flickity-enabled');
            const existingDots = slideshow.parentNode.querySelector('.flickity-page-dots');
            if (existingDots) {
              existingDots.parentNode.removeChild(existingDots);
            }
            
            // Remove any existing button container
            const existingButtons = slideshow.parentNode.querySelector('.flickity-prev-next-button');
            if (existingButtons) {
              existingButtons.parentNode.removeChild(existingButtons);
            }
            
            // Reinitialize Flickity with appropriate options
            const newFlickity = new Flickity(slideshow, options);
            
            // Force Flickity to update its UI elements
            setTimeout(() => {
              newFlickity.resize();
              
              // Manually rebind click events for dots if needed
              const dots = slideshow.parentNode.querySelectorAll('.flickity-page-dots .dot');
              dots.forEach((dot, index) => {
                dot.addEventListener('click', function() {
                  newFlickity.select(index);
                });
              });
              
              // Ensure variant selectors work properly
              const variantSelectors = document.querySelectorAll('.ProductForm__Option .SizeSwatch');
              if (variantSelectors.length > 0) {
                console.log('Ensuring variant selectors work properly in recovery mode');
                
                // Trigger a change event on the product form to reinitialize variant selectors
                const productForm = document.querySelector('.ProductForm');
                if (productForm) {
                  const event = new CustomEvent('product:updated', { bubbles: true });
                  productForm.dispatchEvent(event);
                }
              }
            }, 100);
          }
        } catch (recoveryError) {
          console.error('Failed to recover from error:', recoveryError);
        }
      }
    }
    
    // Listen for variant changes
    document.addEventListener('variant:changed', function(event) {
      const variant = event.detail.variant;
      if (variant && variant.sku) {
        // Small delay to ensure the DOM is updated
        setTimeout(() => {
          try {
            filterSlidesByVariantSKU(variant.sku);
            
            // Scroll to the top of the product gallery
            const productGallery = document.querySelector('.Product__Gallery');
            if (productGallery) {
              // Smooth scroll to the top of the product gallery
              productGallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
              console.log('Scrolled to top of product gallery after variant change');
            } else {
              // Fallback: try to scroll to the product container
              const productContainer = document.querySelector('.Product');
              if (productContainer) {
                productContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                console.log('Scrolled to top of product container after variant change');
              } else {
                // Last resort: scroll to the top of the page
                window.scrollTo({ top: 0, behavior: 'smooth' });
                console.log('Scrolled to top of page after variant change');
              }
            }
          } catch (error) {
            console.error('Error handling variant change:', error);
          }
        }, 100);
      }
    });
    
    // Initial filtering based on selected variant
    const selectedVariantId = document.querySelector('[name="id"]')?.value;
    if (selectedVariantId) {
      const selectedVariant = productData.variants.find(v => v.id.toString() === selectedVariantId);
      if (selectedVariant && selectedVariant.sku) {
        // Delay initial filtering to ensure Flickity is fully initialized
        setTimeout(() => {
          try {
            filterSlidesByVariantSKU(selectedVariant.sku);
          } catch (error) {
            console.error('Error during initial filtering:', error);
          }
        }, 1500);
      }
    }
  }

  // Initialize the image filtering functionality
  setupProductImageFiltering();
  
  // Add CSS for single image case
  const style = document.createElement('style');
  style.textContent = `
    .single-image-slideshow .flickity-viewport {
      cursor: default !important;
    }
    .single-image-slideshow .flickity-slider {
      transform: none !important;
    }
    .single-image-slideshow .Carousel__Cell {
      position: relative !important;
      left: 0 !important;
      opacity: 1 !important;
      visibility: visible !important;
      transform: none !important;
    }
  `;
  document.head.appendChild(style);
});